var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          d: "M14,4 C14.5522847,4 15,4.44771525 15,5 L15,6.25 L18,4 L18,10 L15,7.75 L15,9 C15,9.55228475 14.5522847,10 14,10 L8,10 C7.44771525,10 7,9.55228475 7,9 L7,5 C7,4.44771525 7.44771525,4 8,4 L14,4 Z",
        },
      }),
      _c("g", { attrs: { transform: "translate(5.000000, 14.000000)" } }, [
        _c("line", {
          attrs: {
            x1: "4.75",
            y1: "3",
            x2: "9.75",
            y2: "3",
            stroke: "#6A1B9A",
            "stroke-width": "2",
            "stroke-linecap": "square",
          },
        }),
        _c("polygon", {
          attrs: {
            transform:
              "translate(2.000000, 3.000000) rotate(-90.000000) translate(-2.000000, -3.000000) ",
            points: "2 1 5 5 -1 5",
          },
        }),
        _c("polygon", {
          attrs: {
            transform:
              "translate(12.000000, 3.000000) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -3.000000) ",
            points: "12 1 15 5 9 5",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }